export default "__VITE_ASSET__BxeEVc_o__"